import React, { useEffect, useRef } from 'react'
import { Customer, ISellerTableDataItem, ISellerTableProductItem } from '../../../../../modules/API/Seller/models/tableData'
import useWebSocket from '../../../../../generic/hooks/useWebSocket'
import { addIDForTheList } from '../../../../../generic/utils/addUIDForTheList'
import { v4 as uuidv4 } from 'uuid'
import { format } from 'date-fns'

interface IOldProductitem {
  ProductID: number,
  VarietyID: number,
  SizeID: string
}
interface ISoketMessageWithOld {
  old: IOldProductitem,
  new: ISellerTableProductItem
}

interface Props {
  date: Date,
  state: ISellerTableProductItem[],
  setState: (state: ISellerTableProductItem[]) => void | React.Dispatch<React.SetStateAction<ISellerTableProductItem[]>>
  setTableMeta: (tableMeta: Customer[]) => void | React.Dispatch<React.SetStateAction<Customer[]>>
}
const WS_URL = "wss://my.agroline.co.il/wsseller/ws"
const WS_URL_TEST = "ws://192.168.201.53:8093/ws"
const useSellerSoketService = ({
  state,
  setState,
  setTableMeta,
  date
}: Props) => {
  const {
    message,
  } = useWebSocket(WS_URL, `&date=${format(date, 'yyyyMMdd')}`)
  // save every message and make a match of old and new data

  useEffect(() => {
    const messageData = JSON.parse(message)
    if (!messageData) return
    let tempArr = [...state]
    // if message is single object of ISellerTableProductItem
    if (messageData.Product) {
      const soketData = messageData as ISellerTableProductItem
      soketData.id = uuidv4()
      const isExist = tempArr.find(item => item.Product.SizeID === soketData.Product.SizeID && item.Product.ProductID === soketData.Product.ProductID && item.Product.VarietyID === soketData.Product.VarietyID)
      if (isExist) {
        tempArr = tempArr.map(item => {
          if (item.Product.SizeID === soketData.Product.SizeID && item.Product.ProductID === soketData.Product.ProductID && item.Product.VarietyID === soketData.Product.VarietyID) {
            return soketData
          }
          return item
        })
      } else {
        // find similar product in array by productID and paste the object near it
        const findSimilarProductIndex = tempArr.findIndex(item => item.Product.ProductID === soketData.Product.ProductID)
        if (findSimilarProductIndex !== -1) {
          tempArr.splice(findSimilarProductIndex + 1, 0, soketData)
        } else {
          tempArr.push(soketData)
        }
      }
    }
    // if message is initial data ISellerTableDataItem
    if (messageData.Metadata) {
      const soketData = messageData as ISellerTableDataItem
      setTableMeta(soketData.Metadata)
      tempArr = addIDForTheList(soketData.Products)
    }
    // if message has depricated and changed data object of ISellerTableProductItem
    if(messageData.old) {
      const soketData = messageData as ISoketMessageWithOld

      // find product from soket massage and replace old to new
      tempArr = tempArr.map(item => {
        if (item.Product.SizeID.trim() === soketData.old.SizeID.trim() && item.Product.ProductID === soketData.old.ProductID && item.Product.VarietyID === soketData.old.VarietyID) {
          console.log(soketData.new)
          return soketData.new
        }
        return item
      })
    }
    setState(tempArr)
  }, [message, setState, setTableMeta,])
  return (
    undefined
  )
}

export default useSellerSoketService